import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectBedrooms = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('bedroom_total')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
